import type { ChatRoom } from 'models';
import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { usePermissions } from 'permissions';
import { Flex, FormActions, Icon, Modal } from 'ui';
import { useDeleteChatConfirmModal } from '../../hooks';

type P = {
  chatroom: ChatRoom;
  children: ReactNode;
  onChatDeleted: () => Promise<void>;
  onClose: () => void;
};

const ChatInfoModalContent = ({ chatroom, children, onChatDeleted, onClose }: P) => {
  const { canDeleteChat } = usePermissions();
  const handleDeleteSuccess = useCallback(async () => {
    onClose();
    await onChatDeleted();
  }, [onChatDeleted, onClose]);
  const { confirm: confirmDeleteChat, contextHolder: deleteChatConfirmContextHolder } = useDeleteChatConfirmModal({
    onSuccess: handleDeleteSuccess,
  });

  return (
    <>
      {deleteChatConfirmContextHolder}
      <Flex align="stretch" gap="ms" vertical>
        {children}
      </Flex>
      <Modal.HugContent.Footer>
        <FormActions
          left={
            canDeleteChat({ chatroom })
              ? {
                  children: 'Delete chat',
                  danger: true,
                  icon: <Icon icon="delete-2-line" />,
                  onClick() {
                    confirmDeleteChat(chatroom.id);
                  },
                  size: 'middle',
                }
              : undefined
          }
          right={{ children: 'Close', onClick: onClose, size: 'middle' }}
        />
      </Modal.HugContent.Footer>
    </>
  );
};

export default ChatInfoModalContent;
